export function getInventory (value) {
  if (!value) {
    return '-'
  }

  return value >= 10 ? '余票充足' : '仅剩' + value + '张'
}
